export var SipEvent;
(function (SipEvent) {
    SipEvent["AccountStateChanged"] = "SIPAccountStateChanged";
    SipEvent["CallStateChanged"] = "SIPCallStateChanged";
})(SipEvent || (SipEvent = {}));
//# sourceMappingURL=definitions.js.map